import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { NgxAimAdminEditCountryStatesComponent } from './edit-country-states/ngx-aim-admin-edit-country-states.component';
import { NgxAimAdminPrimengModule } from '../../ngx-aim-admin.primeng.module';
import { AppLazyLoadEvent } from '../../../../models';
import { MatchModesPrime } from '../../../../enums';
import { NgxAimAdminCountryStateService } from './ngx-aim-admin-admin-country-state.service';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'ngx-aim-admin-country-states',
  standalone: true,
  imports: [NgxAimAdminPrimengModule, AsyncPipe, NgClass],
  templateUrl: './ngx-aim-admin-country-states.component.html',
  styleUrls: ['./ngx-aim-admin-country-states.component.scss', '../../admin.scss'],
  providers: [DialogService],
})
export class NgxAimAdminCountryStatesComponent {
  @ViewChild('dt') table: Table | undefined;
  data$ = this.entityService.data$;
  isLoading$ = this.entityService.isLoading$;
  dataCount$ = this.entityService.dataCount$;
  lastLazyLoadEvent: AppLazyLoadEvent = {
    globalFilterFields: [],
    filters: {}
  };
  selectedOptions: string[] = [];
  isSyncing = false;

  constructor(
    private entityService: NgxAimAdminCountryStateService,
    private dialogService: DialogService,
  ) {}

  onLazyLoad($event: TableLazyLoadEvent) {
    this.lastLazyLoadEvent = $event;
    const lazyLoadEvent: AppLazyLoadEvent = Object.assign({
      withDeleted: this.selectedOptions.includes('withDeleted'),
      globalFilterFields: this.table?.globalFilterFields || [],
    }, $event);

    this.entityService.onFilterEvent(lazyLoadEvent);
  }

  applyFilterGlobal($event: Event) {
    this.table?.filterGlobal(($event.target as HTMLInputElement).value, MatchModesPrime.CONTAINS);
  }

  openEntity(entityId?: number) {
    const dialog = this.dialogService.open(NgxAimAdminEditCountryStatesComponent, {
      data: entityId,
      header: 'State',
      width: '700px',
      contentStyle: { "max-height": "580px", "overflow": "auto" },
      dismissableMask: true
    });
    dialog.onClose.subscribe(() => {
      this.onLazyLoad(this.lastLazyLoadEvent);
    });
  }
}
